export default {
  aws_role_arn: 'arn:aws:iam::215603268362:role/prod-torvue-cognito-auth',
  aws_project_region: 'us-west-2',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_nVa92NAZ4',
  aws_user_pools_web_client_id: '63256cj3345itv23iauj0utqj',
  aws_cognito_identity_pool_id: 'us-west-2:6d7f6107-e9ca-464e-898b-c8db1e2b00e3',
  aws_mandatory_sign_in: 'enabled',
  Auth: {
    region: 'us-west-2',
    identityPoolId: 'us-west-2:6d7f6107-e9ca-464e-898b-c8db1e2b00e3',
    userPoolId: 'us-west-2_nVa92NAZ4',
    userPoolWebClientId: '63256cj3345itv23iauj0utqj',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH',
    oauth: {
      domain: 'cognitoauth.torvue.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://app.torvue.com/login/',
      redirectSignOut: 'https://app.torvue.com/login/',
      clientId: '63256cj3345itv23iauj0utqj',
      responseType: 'code' //switch to code if you want a refresh token
    }
  }
}
